import { Typography } from '@global-engineering-shared/gweb-material-ui';

import StatusIndicator from 'components/StatusIndicator';
import useStyles from 'components/StatusMessage/StatusMessage.styles';
import {
  DraftStatus,
  LinkedAssetFrameStatus,
  LiveStatus,
  statusColour,
  statusLabel,
} from 'utils/statuses';

type StatusMessageProps = {
  status: LiveStatus | DraftStatus | LinkedAssetFrameStatus;
  isExpanded?: boolean | undefined;
};

const StatusMessage = ({ status, isExpanded }: StatusMessageProps) => {
  const classes = useStyles();

  return (
    <>
      {status && (
        <div className={classes.container}>
          <div className={classes.content}>
            <StatusIndicator color={statusColour(status)} />
            <Typography fontWeight={isExpanded && 600} variant="body2">
              {statusLabel(status)}
            </Typography>
          </div>
        </div>
      )}
    </>
  );
};

export default StatusMessage;
